import { Component } from '@angular/core';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

@Component({
  selector: 'fgbcl-sold-out-reward-status',
  standalone: true,
  imports: [FGBSharedModule],
  templateUrl: './sold-out-reward-status.component.html',
  styleUrl: './sold-out-reward-status.component.scss',
})
export class SoldOutRewardStatusComponent {}
